const defaultText = 'Type header here'
const defaultTextLen = defaultText.length

const HEADER = 'HEADER'
const FOOTER = 'FOOTER'

export const createHeader = () => ({
  entityMap: {
    [HEADER]: {
      type: 'colorblock',
      mutability: 'MUTABLE',
      data: {
        //content: defaultText,
        //backgroundColor: 'cornflowerblue',
      },
    },
  },

  blocks: [
    {
      text: defaultText,
      type: 'atomic',
      entityRanges: [{ offset: 0, length: defaultTextLen, key: HEADER }],
    },
    {
      text: '',
      type: 'unstyled',
    },
  ],
})

export const createFooter = () => ({
  entityMap: {
    [FOOTER]: {
      type: 'colorblock',
      mutability: 'MUTABLE',
      data: {
        //content: defaultText,
        // backgroundColor: 'darkorange',
      },
    },
  },
  blocks: [
    {
      text: defaultText,
      type: 'atomic',
      entityRanges: [{ offset: 0, length: defaultTextLen, key: FOOTER }],
    },
    {
      text: '',
      type: 'unstyled',
    },
  ],
})

// choose an individual colorblock-creating function
const creationFns = {
  createHeader,
  createFooter,
}

// merges results of all colorblock creation functions into one
export default () => {
  const fnNames = Object.keys(creationFns)

  return fnNames.reduce((result, creatorFnName) => {
    const creatorFn = creationFns[creatorFnName]
    const { entityMap, blocks } = creatorFn()
    const entityType = Object.keys(entityMap)[0]

    result.entityMap[entityType] = entityMap[entityType]
    result.blocks = result.blocks.concat(blocks)

    return result
  }, { entityMap: {}, blocks: [] })
}



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/message-templates/color-block.js